<div [ngClass]="{'border': displayBorder}"
        [style.width]="width"
        [style.height]="height">
    <quill-editor #quill
        [ngModel]="html"
        readOnly="true"
        [modules]="{toolbar: false}">
        <!-- <div quill-editor-toolbar style="display: none"></div> -->
    </quill-editor>
</div>
